<template>
  <div class="home">
    
  </div>
</template>

<script>
export default {
  name: "Home"
};
</script>

<style lang="sass" scoped>
.home

</style>



// WEBPACK FOOTER //
// src/vms/pages/views/Home.vue